/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_RenamedInputs */



/**
* | output |
* | --- |
* | "Renamed" |
*
* @param {My_Integrations_RenamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_renamed = /** @type {((inputs?: My_Integrations_RenamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_RenamedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Umbenannt")
	return /** @type {LocalizedString} */ ("Renamed")
});